export default __webpack_public_path__ + "static/media/tajima.40bb05fc.png";